







































  import {Component, Prop, Mixins} from 'vue-property-decorator'
  import {I18nPayload, InputElement, IValidation} from './models'
  import inputThemeMixin from '@/mixins/inputThemeMixin'
import { isEqual } from 'lodash';

  @Component({
    inheritAttrs: false,
    computed: {
      getChBxColor(): boolean {
        return this.$store.getters.getCheckboxLabelColor;
      }
    }
  })
  export default class InputCommon extends Mixins(inputThemeMixin) {

    DURATION = 300;

    @Prop() readonly value!: any;
    @Prop() readonly label?: string;
    @Prop() readonly placeholder?: string;
    @Prop({ default: false }) readonly required?: boolean;
    @Prop({ default: false }) readonly showValidation?: boolean;
    @Prop({ default: false }) readonly readOnly?: boolean;
    @Prop({ default: 'text' }) readonly type?: string;
    @Prop() colorTextCondition!: boolean;
    @Prop({ default:false }) colorCondition!: boolean;

    colorInputText = false

    private touched: boolean = false
    private emphasized: boolean = false
    private validation: IValidation = null


    mounted() {
      if (this.$route.path === '/travels'
          || this.$route.params.id) {
        this.colorInputText = true;
      } 
    }

    get id(): string {
      // @ts-ignore
      return this._uid + '-' + (this.textarea ? 'textarea' : 'input');
    }
    get color(): string {
       this.colorTextCondition = this.colorCondition;
      return (this.colorInputText || this.colorTextCondition) ? '#121212' : '#FFFFFF';
    }

    get mappedType(): string {
      let type = this.type;
      switch (type) {
        case 'phone': return 'text';
        default: return type || 'text';
      }
    }

    get phoneAttributes(): Object {
      return this.type === 'phone' ? {
        pattern: '^[0-9\\s+\\-\\.]+$',
        minlength: 8,
        maxlength: 30
      } : {};
    }

    get attributes(): Object {
      return {
        ...this.$attrs,
        ...this.phoneAttributes
      }
    }

    get textarea(): boolean {
      return this.type === 'textarea';
    }

    get input(): InputElement {
      return (this.$refs?.input as any);
    }

    get inputValue(): string {
      return this.value;
    }
    set inputValue(value: string) {
      this.touch();
      if (this.validation && this.isValid()) this.validation = null;
      value = (this.type === 'email') ? value.toLowerCase() : value;
      this.$emit('input', value);
    }

    private trim(): void {
      this.inputValue = this.inputValue.trim();
    }

    get validationMessage(): string {
      let validation = this.validation;
      return this.validation?.message ||
        (this.validation?.slug ? (this.$t(validation?.slug || '', validation?.payload) as string) : '');
    }

    private touch(): void {
      this.touched = true;
    }

    private emphasize(): void {
      this.emphasized = true;
      setTimeout(() => {
        this.emphasized = false;
      }, this.DURATION);
    }

    private retouch(): void {
      if (!this.value) {
        this.touched = false;
      }
    }

    private focus(): void {
      this.input.focus();
    }

    private reset(): void {
      this.retouch();
      this.resetValidation();
    }

    private isValid(): boolean {
      return this.input?.validity.valid;
    }

    private static getValidationMessage(states: ValidityState, factor: string, payload?: I18nPayload[]): IValidation {
      return (states as any)[factor] ? {
        slug: 'form.errors.' + factor,
        payload: payload
      } : null;
    }

    private sequenceValidate(): boolean {
      let specialSymbols = ['.', '-', ' ', '\''];
      return this.value?.split('').reduce((res: boolean, char: string) => {
        return res || (specialSymbols.indexOf(char) === -1);
      }, false) || !this.value;
    }

    validate(): boolean {
      this.touch();
      if (this.isValid() && this.sequenceValidate()) {
        this.resetValidation();

        return true;
      } else {
        this.emphasize();
        let states: ValidityState = this.input.validity;

        this.validation = (((((((((
          InputCommon.getValidationMessage(states, 'valueMissing')
          || InputCommon.getValidationMessage(states, 'typeMismatch', [this.type as string])
        ) || InputCommon.getValidationMessage(states, 'badInput')
        ) || InputCommon.getValidationMessage(states, 'patternMismatch')
        ) || InputCommon.getValidationMessage(states, 'rangeOverflow', [(this.input as HTMLInputElement).max])
        ) || InputCommon.getValidationMessage(states, 'rangeUnderflow', [(this.input as HTMLInputElement).min])
        ) || InputCommon.getValidationMessage(states, 'stepMismatch', [(this.input as HTMLInputElement).step])
        ) || InputCommon.getValidationMessage(states, 'tooLong', [this.value.length, (this.input as HTMLInputElement).maxLength])
        ) || InputCommon.getValidationMessage(states, 'tooShort', [this.value.length, (this.input as HTMLInputElement).minLength])
        ) || { slug: 'form.errors.default' });

        return false;
      }
    }

    private resetValidation(): void {
      this.validation = null;
    }

  }
